import { CompanyType } from '@@types/api.types';
import { withForm } from '@components/ui/form/form';
import { useStore } from '@tanstack/react-form';
import { resetFieldMeta } from '@utils/form.util';
import { useEffect, useRef } from 'react';
import { companyFormOptions } from './company-form-options';

export const ProfileStep = withForm({
  ...companyFormOptions,
  render: function Render({ form }) {
    const companyType = useStore(form.store, (state) => state.values.type);
    const previousTypeRef = useRef<CompanyType | undefined>(companyType);

    useEffect(() => {
      const previousType = previousTypeRef.current;
      if (companyType === CompanyType.RESEARCH_PROJECT && previousType !== CompanyType.RESEARCH_PROJECT) {
        form.setFieldValue('urls.linkedin', '');
        form.setFieldValue('urls.twitter', '');
        form.setFieldValue('urls.crunchbase', '');
        form.setFieldMeta('urls.linkedin', resetFieldMeta);
        form.setFieldMeta('urls.twitter', resetFieldMeta);
        form.setFieldMeta('urls.crunchbase', resetFieldMeta);
      }
      previousTypeRef.current = companyType;
    }, [companyType, form]);

    return (
      <form.AppForm>
        <form.Subscribe selector={(state) => state.values.type}>
          {(companyType) => (
            <div className="flex w-full flex-col items-start gap-6">
              <form.AppField name="urls.website">
                {(field) => (
                  <field.TextField
                    label="Website"
                    placeholder="https://www.azymmetric.com"
                    type="url"
                  />
                )}
              </form.AppField>
              {companyType !== CompanyType.RESEARCH_PROJECT && (
                <>
                  <form.AppField name="urls.linkedin">
                    {(field) => (
                      <field.TextField
                        label="LinkedIn"
                        placeholder="https://www.linkedin.com/company/azymmetric"
                        type="url"
                      />
                    )}
                  </form.AppField>
                  <form.AppField name="urls.twitter">
                    {(field) => (
                      <field.TextField
                        label="X (formerly Twitter)"
                        placeholder="https://x.com/NASA"
                        type="url"
                      />
                    )}
                  </form.AppField>
                  <form.AppField name="urls.crunchbase">
                    {(field) => (
                      <field.TextField
                        label="Crunchbase"
                        placeholder="https://www.crunchbase.com/organization/azymmetric"
                        type="url"
                      />
                    )}
                  </form.AppField>
                </>
              )}
            </div>
          )}
        </form.Subscribe>
      </form.AppForm>
    );
  },
});
